module.exports = __webpack_public_path__ + "static/media/tela4.25542e7b.png";